import { fromEvent, from, of, EMPTY } from 'rxjs';
import * as Rx from 'rxjs'
import { filter, map, mergeMap, scan, merge, withLatestFrom, groupBy,
  startWith, tap, delay, combineLatest, switchMap, distinctUntilChanged, take, share } from 'rxjs/operators';
import _ from 'lodash'
// import { gql } from 'apollo-boost';
import { Dispatch } from 'architecture'

import { gql } from 'apollo-boost';
import client from '../apollo';

const GET_TAGS = gql`
  {
    tags {
    	id
      name
      color
      type
      children {
        id
      }
  	}
  }
`;

const UPSERT_TAG = gql`
  mutation upsertTag($id: String!, $name: String!, $type: String!, $color: String!, $children: [String!]) {
    upsertTag(id: $id, name: $name, type: $type, color: $color, children: $children) {
      success
    }
  }
`;

const DELETE_TAG = gql`
  mutation deleteTag($id: String!) {
    deleteTag(id: $id) {
      success
    }
  }
`;

Dispatch.getState('auth.user')
  .pipe(
    filter(user => user !== null)
  )
  .pipe(
    merge(Dispatch.getAction('Tags', 'refresh')),
    switchMap(e => from(client
      .watchQuery({ query: GET_TAGS, pollInterval: 100000 }))
      .pipe(
        map(f => f.data.tags.reduce((acc, next) => ({...acc, [next.id]: { ...next, editable: false}}), {})),
       // map(tags => ({...tags}))
        //map(tags => Object.keys(tags).)
        //map(f => f.map(tag => ({id: supplier.id, name: supplier.location.name})))
      )
    )
  )
  .subscribe(e => Dispatch.nextState('Tags', e))

const create$ = Dispatch.getAction('Tags', 'create')
  .pipe(
    //ADD TO CHAT //ADD TO INSTANCE map()
  )

  Dispatch.getAction('Tags', 'edit')
    .pipe(
      withLatestFrom(Dispatch.getState('Tags')),
      map(([id, tags]) => id ? tags[id] : { name: '', type: '', color: '', children: '' }),
    )
    .subscribe(e => {
      Dispatch.nextState('TagEditor', e)
      Dispatch.nextAction('TagEditor', 'open')
    })
  
  Dispatch.getAction('TagEditor', 'update')
    .pipe(
      map(e => ({ [e.type]: e.value, edited: true }))
    )
    .subscribe(e => Dispatch.mergeState('TagEditor', e))

    Dispatch.getAction('TagEditor', 'save')
    .pipe(
      withLatestFrom(Dispatch.getState('TagEditor')),
      mergeMap(([save, tagEditor]) => from(client.mutate({
        mutation: UPSERT_TAG,
        variables: { id: tagEditor.id ? tagEditor.id : '', name: tagEditor.name, type: tagEditor.type, color: tagEditor.color }
      })))
    )
    .subscribe(e => {
      Dispatch.mergeState('TagEditor', { edited: false })
      Dispatch.nextAction('Tags', 'refresh')
    })

    Dispatch.getAction('TagEditor', 'delete')
    .pipe(
      withLatestFrom(Dispatch.getState('TagEditor')),
      mergeMap(([save, tagEditor]) => from(client.mutate({
        mutation: DELETE_TAG,
        variables: { id: tagEditor.id ? tagEditor.id : '' }
      })))
    )
    .subscribe(e => {
      Dispatch.nextState('TagEditor', {name: '', type: '', color: '', children: ''})
      Dispatch.nextAction('Tags', 'refresh')
    })

  Dispatch.getAction('Tag', 'mouseDown')
    .pipe(
      filter(e => document.activeElement.classList.contains('TagInput')),
      tap(e => e.event.preventDefault()),
      map(e => ({...e, id: document.activeElement.id }))
      //add tag to new object
    )
    .subscribe(e => Dispatch.nextAction('TagInput', 'addTag', e))

  // Dispatch.getAction('TagEditor', 'updateName')
  //   .subscribe(e => Dispatch.mergeState('TagEditor', { name: e }))

  // Dispatch.getAction('TagEditor', 'updateType')
  //   .subscribe(e => Dispatch.mergeState('TagEditor', { type: e }))

  // Dispatch.getAction('TagEditor', 'updateColor')
  //   .subscribe(e => Dispatch.mergeState('TagEditor', { color: e }))

// create$
//   .pipe(
//     startWith(tags)
//   )
//   .subscribe(e => Dispatch.mergeState('Tags', e))